import { API_BASE_URL } from "../config";

export const getUserRegistration = async (userId, eventIds, token) => {
  const requestUrl = `${API_BASE_URL}/event/event`;

  const fields = ["*", "user-registered"];

  const filter = [
    {
      property: "id",
      value: eventIds,
      operator: "in",
    },
  ];

  const params = new URLSearchParams({
    access_token: token,
    fields: fields.join(","),
    filter: JSON.stringify(filter),
    userId: userId.toString(),
  });

  try {
    const response = await fetch(`${requestUrl}?${params.toString()}`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const eventAccess = {};
    data?.data.forEach((item) => {
      eventAccess[item.id] = item["user-registered"] ?? false;
    });
    return eventAccess;
  } catch (error) {
    console.error("Error fetching user registration:", error);
    return null;
  }
};
